import { applicationApi } from "../../common/api";
import { Questionaire, QuestionaireResult, QuestionaireResultConfig } from "./types";

// Define a service using a base URL and expected endpoints
export const questionaireApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuestionaire: builder.query<Questionaire[], void>({
      query: () => `fl/questionaire`,
      providesTags: [{ type: "Questionaire", id: "LIST" }],
    }),
    getQuestionaire: builder.query<Questionaire, string>({
      query: (query) => `fl/questionaire/${query}`,
    }),
    createQuestionaire: builder.mutation<Questionaire, any>({
      query: (body) => ({
        url: "/fl/questionaire",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Questionaire", id: "LIST" }],
    }),
    deleteQuestionaire: builder.mutation<any, number>({
      query: (id) => ({
        url: `fl/questionaire/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Questionaire", id: "LIST" }],
    }),
    updateQuestionaire: builder.mutation<Questionaire, any>({
      query: (body) => ({
        url: `/fl/questionaire/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "Questionaire", id: "LIST" }],
    }),

    getAllQuestionaireResult: builder.query<QuestionaireResult[], void>({
      query: () => `fl/questionaire-result`,
      providesTags: [{ type: "QuestionaireResult", id: "LIST" }],
    }),
    getQuestionaireResult: builder.query<QuestionaireResult, string>({
      query: (query) => `fl/questionaire-result/${query}`,
    }),
    deleteQuestionaireResult: builder.mutation<any, number>({
      query: (id) => ({
        url: `fl/questionaire-result/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "QuestionaireResult", id: "LIST" }],
    }),

    getAllQuestionaireResultConfig: builder.query<QuestionaireResultConfig[], void>({
      query: () => `fl/questionaire-result-config`,
      providesTags: [{ type: "QuestionaireResultConfig", id: "LIST" }],
    }),
    getQuestionaireResultConfig: builder.query<QuestionaireResultConfig, string>({
      query: (query) => `fl/questionaire-result-config/${query}`,
    }),
    createQuestionaireResultConfig: builder.mutation<QuestionaireResultConfig, any>({
      query: (body) => ({
        url: "/fl/questionaire-result-config",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "QuestionaireResultConfig", id: "LIST" }],
    }),
    deleteQuestionaireResultConfig: builder.mutation<any, number>({
      query: (id) => ({
        url: `fl/questionaire-result-config/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "QuestionaireResultConfig", id: "LIST" }],
    }),
    updateQuestionaireResultConfig: builder.mutation<QuestionaireResultConfig, any>({
      query: (body) => ({
        url: `/fl/questionaire-result-config/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "QuestionaireResultConfig", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllQuestionaireQuery,
  useGetQuestionaireQuery,
  useCreateQuestionaireMutation,
  useDeleteQuestionaireMutation,
  useUpdateQuestionaireMutation,

  useGetAllQuestionaireResultQuery,
  useGetQuestionaireResultQuery,
  useDeleteQuestionaireResultMutation,

  useGetAllQuestionaireResultConfigQuery,
  useGetQuestionaireResultConfigQuery,
  useCreateQuestionaireResultConfigMutation,
  useDeleteQuestionaireResultConfigMutation,
  useUpdateQuestionaireResultConfigMutation,
} = questionaireApi;
